import { formOptions } from '@tanstack/react-form';

export type AdminCategoryFormData = {
  description?: string;
  name: string;
  parentCategoryId?: string | null;
  subcategories?: string[];
};

export const adminCategoryFormOptions = formOptions({
  defaultValues: {
    description: undefined,
    name: '',
    parentCategoryId: null,
    subcategories: [],
  } as AdminCategoryFormData,
});
